import { SelectProps } from 'antd';
import InfiniteSelect from '../../InfiniteSelect';
import {
  useInvoiceGovermentClassificationTaxDetail,
  useInvoiceGovermentClassificationTaxList,
} from '@/core/domain/invoice/government/goverment.hooks';
import { flatInfiniteData } from '@/utils/request/flatInfiniteData';
import {
  InvoiceGovernmentClassificationTaxListRequest,
  InvoiceGovernmentClassificationTax,
} from '@/core/domain/invoice/government/government.types';
import { useMemo, useState } from 'react';
import { useDebounce } from '@/hooks';

interface Props extends SelectProps {
  queryParams: InvoiceGovernmentClassificationTaxListRequest;
  queryEnabled?: boolean;
}

export default function SelectInvoiceClassificationTax({
  queryParams,
  queryEnabled,
  ...props
}: Props) {
  const [search, setSearch] = useState('');
  const searchDebouce = useDebounce(search);

  const cstList = useInvoiceGovermentClassificationTaxList(
    { ...queryParams, search: searchDebouce },
    queryEnabled,
  );
  const cstDetail = useInvoiceGovermentClassificationTaxDetail(props.value);

  const list = flatInfiniteData(cstList.data);

  const geClassTaxLabel = (classTax: InvoiceGovernmentClassificationTax) =>
    `${classTax.code} - ${classTax.description}`;

  const options = useMemo(() => {
    const items = list.map((classTax) => ({
      value: classTax.code,
      label: geClassTaxLabel(classTax),
    }));

    if (items.some((item) => item.value === props.value)) return items;

    if (cstDetail.data)
      return [
        { value: cstDetail.data?.code, label: geClassTaxLabel(cstDetail.data) },
        ...items,
      ];

    return items;
  }, [list, cstDetail.dataUpdatedAt, props.value]);

  return (
    <InfiniteSelect
      {...props}
      options={options}
      fetchNextPage={cstList.fetchNextPage}
      hasNextPage={cstList.hasNextPage}
      loading={cstList.isLoading}
      searchValue={search}
      onSearch={setSearch}
    />
  );
}
